"use client";

import * as DialogPrimitive from "@radix-ui/react-dialog";
import { ReactNode } from "react";
import styles from "./Dialog.module.scss";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

type Props = {
	title: string;
	TriggerComponent: ReactNode;
	ContentComponent: ReactNode;
	open?: boolean;
	onOpenChange?: (open: boolean) => void;
};

/**
 * ダイアログ コンポーネント
 * @param props props
 * @returns ダイアログコンポーネント
 */
export default function Dialog(props: Props) {
	const { title, TriggerComponent, ContentComponent, open, onOpenChange } =
		props;

	return (
		<DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
			<DialogPrimitive.Title>
				<VisuallyHidden>{title}</VisuallyHidden>
			</DialogPrimitive.Title>
			<DialogPrimitive.Trigger asChild>
				{TriggerComponent}
			</DialogPrimitive.Trigger>
			<DialogPrimitive.Portal>
				<DialogPrimitive.Overlay className={styles.overlay}>
					<DialogPrimitive.Content
						onEscapeKeyDown={(e) => e.preventDefault()}
						onPointerDownOutside={(e) => e.preventDefault()}
						className={styles.content}
					>
						{ContentComponent}
					</DialogPrimitive.Content>
				</DialogPrimitive.Overlay>
			</DialogPrimitive.Portal>
		</DialogPrimitive.Root>
	);
}
